/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  DatePicker,
  Card,
  message,
  Tooltip,
} from 'antd';
import * as XLSX from 'xlsx';
import { CheckCircleOutlined, CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_EN_PROCESO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import moment from 'moment';
import Uploader from 'components/Uploader';
import { getJustificaciones } from 'api/catalogos/Clock/TipoJustificacion';
import { getEmpleadosConDatosOpFilteredPaginated } from 'api/estructuraOrganizacional/empleados';
import { getPlaza } from 'api/catalogos/plazas';
import CustomSearch from 'components/customSearch';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getModelPermission } from 'utils/permission';
import {
  getJustificacionReloj, patchJustificacionReloj, postJustificacionReloj,
} from 'api/configuraciones/clock/Justificacion/Justificaciones';
import { getEvaluacionesAsistencia } from 'api/catalogos/TiposDeEvaluacionAsistencia';
import JustificacionAdjuntos, { JustificacionAjuntosPermission } from './JustificacionAdjuntos';

// Se autorizan o rechazan las justificaciones Activas y las En proceso: las que envía el
// empleado desde el Portal del Empleado llegan En proceso (pendientes de RH)
const POR_RESOLVER = [ESTATUS_ACTIVO, ESTATUS_EN_PROCESO];

const JustificacionFormsReloj = ({ datos_padre, autorizar_rechazar, updateTable }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [pageActual, setPageActual] = useState(1);
  const [justificaciones, setJustificaciones] = useState([]);
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [puestosPorEmpleado, setPuestosPorEmpleado] = useState({});
  const [dataSearch, setDataSearch] = useState([]);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [openSearch, setVisibleSearch] = useState(false);
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [confirmationVisible, setConfirmationVisible] = useState(false);

  const getPermission = getModelPermission(
    JustificacionAjuntosPermission.permissionModel,
    JustificacionAjuntosPermission.catalogsModels,
    JustificacionAjuntosPermission.tabsModels,
    false,
  );

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      if (datos_padre._dataId == null || datos_padre._dataId === 0) {
        return;
      }
      form.resetFields();
      const data_received = await getJustificacionReloj(datos_padre?._dataId);
      const _data = {
        ...formatReceived(data_received),
        area_empleado: datos_padre?.directorio_de_area_clave_y_nombre,
        plaza_empleado: [datos_padre?.categoria, datos_padre?.categoria_nombre]
          .filter(Boolean)
          .join(' - ') || null,
        puesto_empleado: datos_padre?.puesto_clave_y_descripcion,
        tipo_de_evaluacion_de_asistencia: data_received?.tipo_de_evaluacion_de_asistencia.id,
        estados_globales: data_received?.estados_globales?.id,
        empleado_emisor: data_received?.empleado_emisor
          .numero_y_nombre_completo,
        empleado_autorizado_rechazado: data_received?.empleado_autorizado_rechazado
          .numero_y_nombre_completo,
        area_comprobante: data_received?.empleado_autorizado_rechazado
          .directorio_de_area_clave_y_nombre,
        plaza_comprobante: data_received?.empleado_autorizado_rechazado
          .plaza_clave_y_descripcion,
        puesto_comprobante: data_received?.empleado_autorizado_rechazado
          .puesto_clave_y_descripcion,
        carga_de_reporte_detalle: data_received?.carga_de_reporte_detalle.id,
      };
      form.setFieldsValue(_data);
      setSelectedData(_data);
      setSelectedRowKeys([_data?.id]);
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  function buildAutorizadorFields(empleadoResult, plazaEmp) {
    return {
      empleado_autorizado_rechazado: empleadoResult?.numero_y_nombre_completo,
      area_comprobante: plazaEmp?.directorio_de_area_clave_y_nombre,
      plaza_comprobante: `${plazaEmp?.categoria} - ${plazaEmp?.categoria_nombre}`,
      puesto_comprobante: plazaEmp?.puesto_clave_y_descripcion,
    };
  }
  function buildEmisorFields(empleadoResult, plazaEmp) {
    return {
      empleado_emisor: empleadoResult?.numero_y_nombre_completo,
    };
  }

  let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const validateInput = async (field, setterFields) => {
    setLoading(true);
    setSelectedEmpleadoSearch();
    const searchEmp = form.getFieldValue(field);
    if (!searchEmp) {
      setVisibleSearch(true);
      return setLoading(false);
    }
    const res = await getEmpleadosConDatosOpFilteredPaginated(
      `${baseURIDatosOpPaginado}numero_de_empleado=${searchEmp};`,
    );

    const result = res?.results?.[0];

    const plazaEmp = result ? await getPlaza(result.plaza) : null;

    if (!res) {
      return setLoading(false);
    }
    const empleadoResult = result?.empleado;
    if (empleadoResult) {
      const fields = setterFields(empleadoResult, plazaEmp);
      form.setFieldsValue(fields);
    } else {
      form.resetFields([field]);
    }
    // onChangeEmpleado(empleadoResult?.id);
    return setLoading(false);
  };

  const columnsEmpleado = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (empObject) => empObject?.numero_de_empleado,
    },
    {
      titleText: 'Nombre',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.nombre,
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_paterno,
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_materno,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (_, empObject) => puestosPorEmpleado[empObject.id],
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
    },
  ];

  const findPuesto = async (empleados) => {
    const nuevosPuestos = {};
    await Promise.all(
      empleados.map(async (emp) => {
        try {
          const plazaEmp = await getPlaza(emp.plaza);
          nuevosPuestos[emp.id] = plazaEmp?.puesto_descripcion || '';
        } catch {
          nuevosPuestos[emp.id] = '';
        }
      }),
    );

    setPuestosPorEmpleado(nuevosPuestos);
  };

  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    if (empId) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
    }
    if (nombreEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
    }
    if (apPatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
    }
    if (apMatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
    }
    if (tipoNominaEmpleado) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
    }
    setBaseURIPagination(baseURIDatosOpPaginado);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
    await findPuesto(_empleados.results);
    setDataSearch(_empleados);
    return setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [datos_padre]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _justificaciones,
        _tipos_de_nominas_empleados,
      ] = await Promise.all([
        getEstadosGlobales(),
        getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }),
        getTiposDeNominasEmpleados(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setJustificaciones(_justificaciones);
        setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      // delete fields unwanted:
      delete values.area_comprobante;
      delete values.area_empleado;
      delete values.plaza_empleado;
      delete values.puesto_empleado;
      values.fecha_incidencia = values.fecha_incidencia.format('YYYY-MM-DD');
      values.fecha_justificacion = values.fecha_justificacion.format('YYYY-MM-DD');
      values.fecha_oficio = values.fecha_oficio.format('YYYY-MM-DD');
      values.fecha_otro_comprobante = values.fecha_otro_comprobante.format('YYYY-MM-DD');
      values.empleado_emisor = values.empleado_emisor.id;
      const [numero, nombre] = values.empleado_autorizado_rechazado.split(' - ');
      values.empleado_autorizado_rechazado = numero;

      const saved = await patchJustificacionReloj(key, values);
      onCancel();
      await fetchData();
      await updateTable();
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };
  const onConfirmRechazar = async () => {
    try {
      setLoading(true);
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      // delete fields unwanted:
      delete values.area_comprobante;
      delete values.area_empleado;
      delete values.plaza_empleado;
      delete values.puesto_empleado;
      values.fecha_incidencia = values.fecha_incidencia.format('YYYY-MM-DD');
      values.fecha_justificacion = values.fecha_justificacion.format('YYYY-MM-DD');
      values.fecha_oficio = values.fecha_oficio.format('YYYY-MM-DD');
      values.fecha_otro_comprobante = values.fecha_otro_comprobante.format('YYYY-MM-DD');
      values.empleado_emisor = values.empleado_emisor.id;
      const [numero, nombre] = values.empleado_autorizado_rechazado.split(' - ');
      values.empleado_autorizado_rechazado = numero;

      const saved = await patchJustificacionReloj(key, values);

      onCancel();
      await fetchData();
      await updateTable();
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      // delete fields unwanted:
      delete values.area_comprobante;
      delete values.area_empleado;
      delete values.plaza_empleado;
      delete values.puesto_empleado;
      delete values.motivo_rechazo;
      values.fecha_incidencia = values.fecha_incidencia.format('YYYY-MM-DD');
      values.fecha_justificacion = values.fecha_justificacion.format('YYYY-MM-DD');
      values.fecha_oficio = values.fecha_oficio.format('YYYY-MM-DD');
      values.fecha_otro_comprobante = values.fecha_otro_comprobante.format('YYYY-MM-DD');
      // values.carga_de_reporte_detalle = values.carga_de_reporte_detalle.id;
      values.empleado_emisor = values.empleado_emisor.id;

      const saved = await (key ? patchJustificacionReloj(key, values)
        : postJustificacionReloj(values));
      if (saved) {
        onCancel();
        await fetchData();
        await updateTable();
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          extra={(
            <FormSubmitControls
              onFinish={!autorizar_rechazar ? onFinish : null}
              onFinishText="Guardar Registro"
              customActions={
                autorizar_rechazar ? [
                  {
                    onClick: async () => {
                      try {
                        await form.validateFields();
                        if (form.getFieldValue('motivo_rechazo')) {
                          throw new Error('El motivo de rechazo debe estar vacio al autorizar');
                        }
                        setConfirmationVisible(true);
                      } catch (err) {
                        message.warn(err.message);
                      }
                    },
                    icon: <CheckCircleOutlined />,
                    permission: { model: 'justificacionrelojchecador', action: 'autorizar' },
                    text: 'Autorizar',
                    disabled: !POR_RESOLVER.includes(selectedData?.estados_globales),
                    className: 'success',
                  },
                  {
                    onClick: async () => {
                      try {
                        await form.validateFields();
                        if (!form.getFieldValue('motivo_rechazo')) {
                          throw new Error('El motivo de rechazo es obligatorio');
                        }
                        setVisibleCancelar(true);
                      } catch (err) {
                        message.warn(err.message);
                      }
                    },
                    text: 'Rechazar',
                    icon: <CloseCircleOutlined />,
                    className: 'cancel',
                    // eslint-disable-next-line max-len
                    disabled: !POR_RESOLVER.includes(selectedData?.estados_globales),
                  },
                ] : []
              }
            />
          )}
          bordered={false}
        >

          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
              reemplazo_de_archivo: false,
            }}
          >
            <Row gutter={10}>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="minutos_retardo"
                  label="Incidencia"
                >
                  <Input
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="fecha_incidencia"
                  label="Fecha de Incidencia"
                >
                  <DatePicker
                    placeholder=""
                    allowClear
                    format="YYYY-MM-DD"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="fecha_justificacion"
                  label="Fecha de Justificación"
                >
                  <DatePicker
                    placeholder=""
                    allowClear
                    format="YYYY-MM-DD"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="tipo_de_evaluacion_de_asistencia"
                  label="Tipo de Justificación"
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={justificaciones}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={16}>
                <Form.Item
                  name="justificacion"
                  label="Justificación"
                >
                  <Input
                    allowClear
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="numero_oficio"
                  rules={rules.required}
                  label="Número de Oficio"
                >
                  <Input
                    allowClear
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="fecha_oficio"
                  rules={rules.required}
                  label="Fecha de Oficio"
                >
                  <DatePicker
                    placeholder=""
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Row align="middle">
                  <Col xs={24} sm={24} md={24}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Form.Item
                        name="empleado_emisor"
                        label="Emisor del Oficio"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={!selectedRowKeys?.length}
                        />
                      </Form.Item>
                      <Button
                        loading={loading}
                        onClick={() => validateInput('empleado_emisor', buildEmisorFields)}
                        icon={<SearchOutlined />}
                        style={{
                          width: '2.7rem',
                          height: '2rem',
                        }}
                        disabled={!selectedRowKeys?.length}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="area_empleado"
                  label="Área"
                >
                  <Input
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="plaza_empleado"
                  label="Plaza"
                >
                  <Input
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="puesto_empleado"
                  label="Puesto"
                >
                  <Input
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="otro_comprobante_soporte"
                  rules={rules.required}
                  label="Otro Comprobante Soporte"
                >
                  <Select
                    trueFalse
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="descripcion_otro_comprobante"
                  label="Descripción de Otro Comprobante Soporte"
                >
                  <Input
                    allowClear
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="fecha_otro_comprobante"
                  rules={rules.required}
                  label="Fecha de Otro Comprobante Adjunto"
                >
                  <DatePicker
                    placeholder=""
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    activeInactive={selectedData?.estados_globales === ESTATUS_ACTIVO}
                    disabled={selectedRowKeys.length <= 0 || disableFields}
                    onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="carga_de_reporte_detalle"
                  label="Carga Reporte"
                  hasFeedback
                  hidden
                >
                  <Input
                    disabled
                  />
                </Form.Item>
              </Col>
              <JustificacionAdjuntos
                disable={disableFields}
                permissions={getPermission}
                selected={selectedRowKeys}
                isBlocked={false}
              />
              {autorizar_rechazar && (
                <>
                  <Col xs={24} sm={24} md={8}>
                    <Row align="middle">
                      <Col xs={24} sm={24} md={24}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <Form.Item
                            name="empleado_autorizado_rechazado"
                            label="Autorizó / Rechazó"
                            hasFeedback
                          >
                            <Input
                              allowClear
                              disabled={!selectedRowKeys?.length}
                            />
                          </Form.Item>
                          <Button
                            loading={loading}
                            onClick={() => validateInput('empleado_autorizado_rechazado', buildAutorizadorFields)}
                            icon={<SearchOutlined />}
                            style={{
                              width: '2.7rem',
                              height: '2rem',
                            }}
                            disabled={!selectedRowKeys?.length}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} sm={8}>
                    <Form.Item
                      name="area_comprobante"
                      label="Área"
                      rules={rules.required}
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8}>
                    <Form.Item
                      name="plaza_comprobante"
                      label="Plaza"
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8}>
                    <Form.Item
                      name="puesto_comprobante"
                      label="Puesto"
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8}>
                    <Tooltip title="Se ignora este campo al autorizar, obligatorio al rechazar">
                      <Form.Item
                        name="motivo_rechazo"
                        label="Motivo de Rechazo"
                      >
                        <Input
                          allowClear
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Tooltip>
                  </Col>
                </>
              )}
            </Row>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Card>

        <CustomSearch
          form={form}
          open={openSearch}
          setVisible={setVisibleSearch}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={setSelectedEmpleadoSearch}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          data={dataSearch}
          setData={setDataSearch}
          searchData={searchData}
          onChange={(row) => {
            setSelectedEmpleadoSearch(row);
          }}
        />
        <ModalConfirmation
          onFinish={onConfirmRechazar}
          Confirm
          onCancel={() => { setVisibleCancelar(false); }}
          open={visibleCancelar}
          contentTitle={`Rechazar la justificacion ${selectedData?.archivo_nombre || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar la justificacion${selectedData?.archivo_nombre || ''}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default JustificacionFormsReloj;
